// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/chips/chips.scss
// module id = 140
// module chunks = 0